import React from 'react'
import PropTypes from 'prop-types'

import Unavailable from 'Catalog/Availability/Unavailable'
import AvailabilityLoading from 'Catalog/Availability/AvailabilityLoading'
import { PriceLabelContainer } from 'Catalog/Availability/PriceLabel'

const ProductAvailability = ({ isLoading, isAvailable, price, changeContext, showInstallments, sku, vendorId }) => (
  <AvailabilityLoading isLoading={isLoading && !isAvailable}>
    {isAvailable ? <PriceLabelContainer sku={sku} vendorId={vendorId} showInstallments={showInstallments} hasDiscount={price && price.regularPrice > price.price} {...price} changeContext={changeContext} /> : <Unavailable />}
  </AvailabilityLoading>
)

ProductAvailability.propTypes = {
  sku: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  isAvailable: PropTypes.bool,
  price: PropTypes.object,
  changeContext: PropTypes.bool,
  showInstallments: PropTypes.bool,
  vendorId: PropTypes.string
}

ProductAvailability.defaultProps = {
  isLoading: true
}

export default ProductAvailability



// WEBPACK FOOTER //
// ./src/Catalog/Availability/ProductAvailability.js